import { render, staticRenderFns } from "./Bahn1Updates.vue?vue&type=template&id=65151398&scoped=true&"
import script from "./Bahn1Updates.vue?vue&type=script&lang=js&"
export * from "./Bahn1Updates.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1Updates.vue?vue&type=style&index=0&id=65151398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65151398",
  null
  
)

export default component.exports